module.exports = __webpack_public_path__ + "img/footer-logo.80f4a410.png";